import {gInterText, render, toolboxScrollToNode} from '../guide/highlight';
import BlockHighlight from '../guide/block-highlight';
import {OPACITY_FOCUS_COVER, ZINDEX_FOCUS_COVER} from './constant';
import React from 'react';

/**
 * 获取元素相对页面的位置
 * @param element
 */
const getElementRect = function(element) {
    if (element) {
        const rect = element.getBoundingClientRect();
        const app = window.appTarget.getBoundingClientRect();
        return {
            left: rect.left - app.left,
            top: rect.top - app.top,
            width: rect.width,
            height: rect.height
        }
    }else {
        return null;
    }
}

/**
 * 等待界面上的元素出现，并返回
 * @param _element
 * @param index 第几个匹配
 * @param timeout 最大等待时间
 * @returns {Element}
 */
const selectElement = async function (_element, index, timeout) {
    if (!timeout) timeout = 1000;
    let element;
    if (typeof _element === 'string') {
        if (index) {
            element = document.querySelectorAll(_element)[index];
        }else {
            element = document.querySelector(_element);
        }
        if (!element) {
            let gs = document.querySelectorAll('.blocklyFlyoutButton');
            for (let i = gs.length - 1; i >= 0; --i) {
                if (gInterText(gs[i]) === _element.trim()) {
                    element = gs[i];
                    await toolboxScrollToNode(element);
                }
            }
        }
        if (!element) {
            let gs = document.querySelectorAll('.blocklyDraggable');
            for (let i = gs.length - 1; i >= 0; --i) {
                if (gInterText(gs[i]) === _element.trim()) {
                    element = gs[i];
                    await toolboxScrollToNode(element);
                }
            }
        }
    } else if (typeof _element === 'function') {
        element = _element();
    } else if (typeof _element === 'object') { //传入的直接是元素
        element = _element;
    }
    if (!element) { //可能时界面尚未渲染，监控等待目标的出现
        await new Promise((resolve) => {
            let count = 0;
            let intval = setInterval(()=>{
                if (typeof _element === 'string') {
                    if (index) {
                        element = document.querySelectorAll(_element)[index];
                    }else {
                        element = document.querySelector(_element);
                    }
                } else if (typeof _element === 'function') {
                    element = _element();
                }
                ++count;
                if (element || count > timeout / 100) {
                    clearInterval(intval);
                    resolve();
                }
            }, 100);
        });
    }
    return element;
}

/**
 * 判断两个区域的左上角是否接近
 * @param rect1
 * @param rect2
 * @param maxDistance
 * @returns {boolean|boolean}
 */
const isRectNear = function(rect1, rect2, maxDistance) {
    if (maxDistance === undefined) maxDistance = 10;
    return (Math.abs(rect1.top - rect2.top) < maxDistance && Math.abs(rect1.left - rect2.left) < maxDistance);
}

/**
 * el是否在parentEl中
 * @param el
 * @param parentEl
 */
const isInElement = function(el, parentEl) {
    while (el && el !== parentEl) {
        el = el.parentElement;
    }
    return el === parentEl;
}
/**
 * 将字符串中的中文标点替换为英文
 */
const cnMarkToEnMark = (str) => {
    const map = {
        '。': '.',
        '？': '?',
        '！': '!',
        '，': ',',
        '、': ',',
        '；': ';',
        '：': ':',
        '“': '"',
        '”': '"',
        '’': "'",
        '‘': "'",
        '（': '(',
        '）': ')',
        '《': '<<',
        '》': '>>',
        '〈': '<',
        '〉': '>',
        '【': '[',
        '】': ']',
        '『': '[',
        '』': ']',
        '「': '[',
        '」': ']',
        '﹃': '[',
        '﹄': ']',
        '〔': '[',
        '〕': ']',
        '…': '...',
        '—': '-',
        '～': '~',
        '﹏': ' ',
        '￥': '$'
    };
    let newStr = '';
    for (let i = 0; i < str.length; ++i) {
        if (map[str[i]] !== undefined) {
            newStr += map[str[i]];
        }else {
            newStr += str[i];
        }
    }
    return newStr;
}

/**
 * 显示一个全局半透明遮罩
 * @param zIndex
 * @param opacity
 */
const renderCover = (zIndex, opacity) => {
    if (zIndex === undefined) zIndex = ZINDEX_FOCUS_COVER;
    if (opacity === undefined) opacity = OPACITY_FOCUS_COVER;
    const sourceRect = {left: 0, top: 0, width: 0, height: 0}
    render(<BlockHighlight
        opacity={opacity}
        zIndex={zIndex}
        getCurrentRect={() => sourceRect}
    />);
}

/**
 * 隐藏toolbox的flyout
 */
const hideFlyout = () => {
    window._Blockly.getMainWorkspace().getToolbox().flyout_.setVisible(false);
}


/**
 * 页面顶部导航栏返回
 * @param  history
 */

const headNavBack = (history) => {
    if (history.length === 1) {
        location.href = origin;
        return
    }
    if (document.referrer) {
        if ((document.referrer == window.location.href) && history.length === 2) {
            location.href = origin;
            return
        } else {
            history.go(-1);
        }
    } else if (history.length > 2) {
        history.go(-1);
    } else {
        location.href = origin;
    }
    localStorage.setItem('refresh','true');
}

export {
    getElementRect,
    isRectNear,
    selectElement,
    isInElement,
    cnMarkToEnMark,
    renderCover,
    hideFlyout,
    headNavBack
}
